import { format } from 'date-fns';
import React from 'react';
import { api_auth, api_host } from '../common/globals/constants';
import { getApiKeys } from '../utils/fns/get-api-keys';
import { useQuery } from '@tanstack/react-query';

export function useDisponibilidadISP({
  objetivoId,
  fechaInicio,
  fechaTermino,
  time = 'c',
  horarioId = 0,
  enabled = true,
  refreshTime = false,
}) {
  return useQuery({
    queryKey: [
      'disponibilidad-isp',
      objetivoId,
      fechaInicio,
      fechaTermino,
      time,
      horarioId,
    ],
    queryFn: async () => {
      const apiKeys = getApiKeys();
      const token = apiKeys.token;
      const userId = apiKeys.user;
      const inicio = format(new Date(fechaInicio), 'yyyy-MM-dd');
      const termino = format(new Date(fechaTermino), 'yyyy-MM-dd');

      const requestUrl =
        time === 'c'
          ? `${api_host}/reporte/online/indicadores/calculoDisponibilidaNodo/?t=${time}&nodoId=0&user=${userId}&key=${api_auth}&objetivoId=${objetivoId}&token=${token}&fechaInicio=${inicio}&fechaTermino=${termino}&horarioId=${horarioId}&fecha=${new Date().getTime()}`
          : `${api_host}/reporte/online/indicadores/calculoDisponibilidaNodo/?t=${time}&nodoId=0&user=${userId}&key=${api_auth}&objetivoId=${objetivoId}&token=${token}&horarioId=${horarioId}&fecha=${new Date().getTime()}`;
      const response = await fetch(requestUrl);
      if (!response.ok) {
        throw new Error('Error al obtener la configuración');
      }
      const myJson = await response.json();
      return myJson;
    },
    enabled,
    gcTime: 0, // 24 hours
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: refreshTime || false,
    retry: false,
  });
}
